// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.
import Vue from 'vue'
import App from './App'
import router from './router'
import VueResource from 'vue-resource'
import VeeValidate from 'vee-validate'
import SocialSharing from 'vue-social-sharing'
import VueParticles from 'vue-particles'
import vbclass from 'vue-body-class'
import Buefy from 'buefy'
import VueProgressiveImage from 'vue-progressive-image'
import VueAnalytics from 'vue-analytics'
import VueGtm from 'vue-gtm'

import {VeeValidateConfig, VeeValidateDictionary} from './helpers/VeeValidateConfig'

// Require the main Sass manifest file
require('./assets/vendors/bulmaCustom.scss')

Vue.use(VueResource)
Vue.use(SocialSharing)
VeeValidate.Validator.localize(VeeValidateDictionary)
Vue.use(VeeValidate, VeeValidateConfig)
Vue.use(VueParticles)
Vue.use(vbclass, router)
Vue.use(Buefy, {defaultIconPack: 'fas'})
Vue.use(VueProgressiveImage)
Vue.use(VueAnalytics, {id: 'UA-120933243-1', router})
Vue.use(VueGtm, {
  // enabled: true, // defaults to true. Plugin can be disabled by setting this to false for Ex: enabled: !!GDPR_Cookie (optional)
  debug: true, // Whether or not display console logs debugs (optional)
  vueRouter: router //, // Pass the router instance to automatically sync with router (optional)
  // ignoredViews: ['homepage'] // If router, you can exclude some routes name (case insensitive) (optional)
})

Vue.config.productionTip = false

Vue.filter('capitalize', function (value) {
  if (!value) return ''
  value = value.toString()
  return value.charAt(0).toUpperCase() + value.slice(1)
})

export const bus = new Vue()

/* eslint-disable no-new */
new Vue({
  el: '#app',
  router,
  components: { App },
  template: '<App/>'
})



// WEBPACK FOOTER //
// ./src/main.js